import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'particle-archive-dialog',
  templateUrl: './archive-dialog.component.html',
  styleUrls: ['./archive-dialog.component.scss']
})
export class ArchiveDialogComponent implements OnInit, IDialogView {
  inputForm: any;
  inputFormErrors: any;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      comment : "",
      title  : [this.data.input['title'], Validators.required]
    });
    this.inputForm.valueChanges.subscribe(formValue=>{
      this.onFormValuesChanged();
    });
  }
  onFormValuesChanged() {
    for (const field in this.inputFormErrors) {
      if (!this.inputFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormErrors[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormErrors[field] = control.errors;
      }
    }
    //this.data.isDisabledOkButton = !this.inputForm.valid;
  }
  data: DialogModel;

  onOkClicked(): boolean {
    this.data.input['comment'] = this.inputForm.controls['comment'].value;
    return true;
  }

}
